// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: 'AIzaSyCGDUygk4Z-nGqqtNZCbuhipzjzmyy8zag',
  authDomain: 'hooks-news-bs.firebaseapp.com',
  databaseURL: 'https://hooks-news-bs.firebaseio.com',
  projectId: 'hooks-news-bs',
  storageBucket: 'hooks-news-bs.appspot.com',
  messagingSenderId: '342309583731',
  appId: '1:342309583731:web:17bb4fb138936299'
};

export default firebaseConfig;

